import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../Model/Common/common.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-resignation-reason-master-form',
  standalone: true,
  imports: [CommonModule, LoaderComponent, FormsModule],
  templateUrl: './resignation-reason-master-form.component.html',
  styleUrl: './resignation-reason-master-form.component.scss'
})
export class ResignationReasonMasterFormComponent {

  @Input() SiteGroupMasterID!: number;
  @Input() SiteGroupCode!: string;
  @Input() SiteGroupName!: string;
  @Input() IsActive!: any
  isDisabled: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    public common: CommonService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    if (this.SiteGroupMasterID > 0) {
      this.filter.Id = this.SiteGroupMasterID;
      this.filter.Code = this.SiteGroupCode;
      this.filter.Name = this.SiteGroupName;
      this.filter.Active = this.IsActive;
      console.log(this.IsActive);
    }
  }

  filter = {
    Id: null as any,
    Code: '',
    Name: '',
    Active: true,
  }

  async InsertUpdate() {
    // await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you sure want to save?'
    modalRef.result.then((result: any) => {
      // if ((this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)) {
      // if (result) {
      //   this.isDisabled = true;
      //   this.group.saveGroup({
      //     SelectType: this.SiteGroupMasterID > 0 ? 'Update' : "Insert",
      //     SiteGroupMasterID: this.filter.Id,
      //     SiteGroupCode: this.filter.Code,
      //     SiteGroupName: this.filter.Name,
      //     IsActive: this.filter.Active
      //   }).subscribe({
      //     next: (response) => {
      //       if (response.Error_Code == '845' || response.Error_Code == '848') {
      //         this.isDisabled = false
      //         const modalRef = this.modalService.open(AlertSuccessComponent, {
      //           size: 'md',
      //           backdrop: 'static',
      //           centered: true,
      //           windowClass: 'confirmation-modal'
      //         });
      //         modalRef.componentInstance.Message = response.Error_Message;
      //         modalRef.result.then((result: any) => {
      //           if (result) {
      //             this.activeModal.close(true);
      //           }
      //         });
      //       }
      //       else {
      //         this.isDisabled = false;
      //         const modalRef = this.modalService.open(AlertWarningComponent, {
      //           size: 'md',
      //           backdrop: 'static',
      //           centered: true,
      //           windowClass: 'confirmation-modal'
      //         });
      //         modalRef.componentInstance.Message = response.Error_Message;
      //         modalRef.result.then((result: any) => { });
      //       }
      //       this.isDisabled = false;
      //     },
      //     complete: () => { },
      //     error: (error) => {
      //       this.isDisabled = false;
      //     },
      //   });
      // }
      // } 
      // else {
        // this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      // }

    }).catch(() => {
      // Modal dismissed
    });
  }

  Validate(form: any) {
    if (form.valid) {
      this.InsertUpdate();
    } else {
      form.submitted = true;
    }
  }

  close() {
    this.activeModal.close();
  }


}
